module.exports = __webpack_public_path__ + "img/floppy-save.bc1395e6.svg";